export default "__VITE_ASSET__456406d3__"